<template>
    <div class="landingsPopup">
        <vs-table :noDataText="$t('table.No_data_available')" ref="table" :data="landing_status">
            <template slot="thead">
                <vs-th sort-key="name">{{$t('modals.Landing_name')}}</vs-th>
                <vs-th class="text-center" v-for="(value, key) in excludeKey(listKeyForExclude, landing_status[0])" :key="key">{{key}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <template v-for="(tr, index) in data">
                    <vs-tr :key="index">
                        <vs-td>
                            <p class="product-name font-medium truncate">{{tr.landing_name}}</p>
                        </vs-td>
                        <vs-td v-for="(value, key) in excludeKey(listKeyForExclude, tr)" :key="key">
                            <div class="flex justify-center">
                                <Info
                                    :length="~~tr[key]"
                                    :total="~~tr.total"
                                    :field="key"
                                />
                            </div>
                        </vs-td>
                        <template slot="expand">
                            <Cards :dataCard="land_team_status"/>
                        </template>
                    </vs-tr>
                </template>
                </tbody>
            </template>
        </vs-table>
    </div>
</template>

<script>
import Table from '@/components/custom-table/Table'
import Cards from './Cards'
import Info from './Info'
import ErrorHandler from '../../../utils/errorHandler'
import {exclude} from '@/utils/mixins'

export default {
    props: ['popupData', 'popupButton', 'popupType'],
    mixins: [exclude],

    data() {
        return {
            landing_status: [],
            land_team_status: [],
            listKeyForExclude: ['landing_name', 'total']
        }
    },

    components: {
        Table,
        Cards,
        Info
    },

    async mounted() {
        try {
            const fn_replace = params => {
                const obj = {}
                const list = {
                    date_from: 'start',
                    date_to: 'end',
                    date_field: 'direction'
                }

                Object.keys(params).map(key => {
                    if (list[key]) {
                        obj[list[key]] = params[key]
                    } else {
                        obj[key] = params[key]
                    }
                })
                return obj
            }

            const response = await this.$store.dispatch('getAdvertiserStatisticById', {...fn_replace(this.$route.query), offer_id: this.popupData.offer_id})
            this.landing_status = response.landing_status
            this.land_team_status = response.land_team_status
        } catch (e) {
            new ErrorHandler(e).send
        }
    }
}
</script>

<style lang="scss">
    .landingsPopup {
        .vs-table {
            border-collapse: collapse;
            /*margin-bottom: 30px;*/
            /*border-spacing: 0 0 2rem 0;*/
            padding: 0 1rem;
            tr{
                margin-bottom: 30px;
                &.spacer {
                    background: none;
                    box-shadow: none;
                    & td {
                        padding: 5px;
                    }
                }
                td{
                    /*padding: 20px;*/
                    &:first-child{
                        border-top-left-radius: .5rem;
                        border-bottom-left-radius: .5rem;
                        &.td-check {
                            max-width: 30px;
                            padding: 20px 0 20px 15px!important;
                        }
                    }
                    &:last-child{
                        border-top-right-radius: .5rem;
                        border-bottom-right-radius: .5rem;
                    }
                    .vs-button.small {
                        padding: 0.5rem 1rem;
                        &.includeIcon {
                            padding: 0.5rem 1rem 0.5rem 0.7rem;
                        }
                    }
                }
                td.td-check{
                    padding: 20px !important;
                }
                &.tr-expandedx {
                    td {
                        &:first-child{
                            border-bottom-left-radius: 0;
                        }
                        &:last-child{
                            border-bottom-right-radius: 0;
                        }
                    }
                }
                &.tr-expand {
                    border-top: 1px solid #ececec;
                    td {
                        padding: 5px;
                        background-color: #F7F7F7 !important;
                        &:first-child{
                            border-top-left-radius: 0;
                        }
                        &:last-child{
                            border-top-right-radius: 0;
                        }
                        .content-tr-expand {
                            padding: 0;
                            border: none;
                        }
                    }
                }
            }
        }
    }
</style>
